
import { computed, defineComponent, ref, watch } from "vue";
import DisplaySection from "@/components/drawers/left/DisplaySection.vue";
import EnergyRatingChart from "./EnergyRatingChart.vue";
import Spinner from "@/components/shared/Spinner.vue";
import { useLocation, useOrgSettings } from "@/services";
import { AnyLocation, IDisplaySection } from "@/types";

export default defineComponent({
  components: { DisplaySection, EnergyRatingChart, Spinner },
  props: {},
  setup() {
    const epcRatingSettings = computed(
      () => useOrgSettings().selectedBusinessLine?.epcRating
    );
    const locationStore = useLocation();
    const isLoading = computed(() => locationStore.isEnergyRatingLoading);
    const coverage = computed(() => epcRatingSettings.value?.coverage || "");
    const country = computed(() => epcRatingSettings.value?.country || "");
    const energyRating = computed(() => locationStore.energyRating);
    const errorMessage = ref<string | undefined>(undefined);

    const isPolicy = computed(() => locationStore.location?.type === "Policy");

    const createSection = (name: string): IDisplaySection => ({
      name,
      items: [],
      type: "",
    });

    watch(
      () => locationStore.location,
      async (location) => {
        if (location) {
          try {
            errorMessage.value = undefined;
            await locationStore.loadEnergyRating(location as AnyLocation);
          } catch (e) {
            errorMessage.value = e.response.data.Message;
          }
        }
      }
    );

    return {
      isLoading,
      errorMessage,
      energyRating,
      isPolicy,
      coverage,
      country,
      createSection,
    };
  },
});
